import React from 'react';
import TopCards from './TopCards';
import MiddleSection from './MiddleSection';
import AutomationSection from './AutomationSection';

// Analytics is the main component that serves as the container for the analytics dashboard.
// It renders the layout for the analytics page, including a title, description, and child components.
const Analytics: React.FC = () => {
  return (
    <div className='p-2'>
      <h2 className='text-[24px] font-bold text-[#3F5265]'>Analytics</h2>
      <p className='text-[16px] mb-6 text-[#657584]'>
        Performance insights for your email campaigns.
      </p>

      {/* Renders the TopCards component to display key metrics in card format */}
      <TopCards />
      {/* Renders the MiddleSection component to show campaign trends and top-performing links */}
      <MiddleSection />
      {/* Renders the AutomationSection component to display automation and campaign performance charts */}
      <AutomationSection />
    </div>
  );
};

export default Analytics;
